module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/work/components/project-sprint/project-sprint.component.css
// module id = ./src/app/modules/work/components/project-sprint/project-sprint.component.css
// module chunks = main